module.exports = __webpack_public_path__ + "img/bz27@2x.35231314.png";